<!-- =========================================================================================
  File Name: AddNewDataSidebar.vue
  Description: Add New Data - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary"
    class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
      <h4>{{ isResetPassword ? $t('ResetPassword') : (Object.entries(this.data).length === 0 ? $t('AddNew') : $t('Update'))
      }} </h4>
      <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <VuePerfectScrollbar class="scroll-area--data-list-add-new" :settings="settings">

      <div class="p-6">
        <div v-if="!isResetPassword">
          <p class="mt-5" style="font-size: 12px;">{{ $t('Role *') }}</p>
          <v-select class="w-full" autocomplete
            name="RoleName"
           label="Name"
           v-if="!isResetPassword" v-model="RoleName"
            :options="roles" :reduce="role => role.Name"  v-validate="'required'" @blur="$validator.validate('RoleName')"
             @input="getRole(RoleName)"
            /> 
            <span class="text-danger text-sm" v-show="errors.has('RoleName')">{{ errors.first('RoleName') }}</span>
        </div>

        <div v-if="!isResetPassword && RoleName !== 'SuperAdmin'"
         >
        <p class="mt-5" style="font-size: 12px;">{{ $t('Country') }}</p>
       <v-select 
            class="mt-1"
            :options="Countries" 
            :label="currentLocale === 'ar' ? 'NameAr' : 'NameEn'" 
            v-model="CountryId" 
            :reduce="c => c.ID" 
        
          />
      </div>

      

        <!-- NAME -->
        <vs-input :disabled="isResetPassword" :label="$t('Full Name *')" v-model="FullName" class="mt-5 w-full"
          name="FullName"  v-validate="'required|min:3'" @blur="$validator.validate('item-name')"  />
          <span class="text-danger text-sm" v-show="errors.has('FullName')">{{ errors.first('FullName') }}</span>

        <!-- Email -->
        <vs-input v-if="!isResetPassword" :label="$t('Email *')" v-model="Email" class="mt-5 w-full" name="Email"
          type="Email" v-validate="'required|email|min:3'" />
        <span class="text-danger text-sm" v-show="errors.has('Email')">{{ errors.first('Email') }}</span>

        <!-- PhoneNumber -->
        <vs-input v-if="!isResetPassword" :label="$t('Phone Number *')" v-model="PhoneNumber" class="mt-5 w-full"
          name="PhoneNumber" type="text"  v-validate="'required|numeric|min:6'" @blur="$validator.validate('PhoneNumber')" />
       <span class="text-danger text-sm" v-show="errors.has('PhoneNumber')">{{ errors.first('PhoneNumber') }}</span>


      
        <!-- password -->
        <vs-input v-if="isResetPassword || isNewUser" icon-pack="feather" :label-placeholder="$t('Password')" icon-after="true" :type="passwordType"
          icon="icon icon-eye-off" @icon-click="showPassword()" :label="$t('Password')" v-model="Password"
          class="mt-5 w-full" @input="checkPassword" name="password" :disabled="ID != '' && ID != null && !isResetPassword"
          v-validate="'required|min:8'" />
        <span class="text-danger text-sm" v-show="errors.has('password') && isResetPassword">{{ errors.first('password') }}</span>

        <ul class="ml-2 mt-3" v-if="isResetPassword || isNewUser">
          <li v-bind:class="{ is_valid: contains_eight_characters }">8 {{ $t('Characters') }}</li>
          <li v-bind:class="{ is_valid: contains_number }">{{ $t('ContainsNumber') }}</li>
          <li v-bind:class="{ is_valid: contains_uppercase }">{{ $t('ContainsUppercase') }}</li>
          <li v-bind:class="{ is_valid: contains_special_character }">{{ $t('ContainsSpecialCharacter') }}</li>
        </ul>

      </div>
    </VuePerfectScrollbar>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button v-if="isResetPassword" class="mr-6" @click="ResetPassword"
        :disabled="!isFormValid">{{ $t('Submit') }}</vs-button>
      <vs-button v-if="!isResetPassword" class="mr-6" @click="submitData"
        :disabled="!isFormValid">{{ $t('Submit') }}</vs-button>
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">{{ $t('Cancel') }}</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import moduleCountries from "@/store/settings/Country/moduleCountry.js";
import moduleUser from "@/store/user/moduleUser.js";
import vSelect from 'vue-select'
export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    isResetPassword: {
      type: Boolean,
      required: false
    },
    isNewUser: {
      type: Boolean,
      required: false
    },
    data: {
      type: Object,
      default: () => { }
    }
  },

  watch: {
    isSidebarActive(val) {
      
      if (!val) return;
      if (Object.entries(this.data).length === 0) {
        this.initValues();
        this.$validator.reset();
      } else {
        
        let { Id, UserName, FullNameAr, FullNameEn, PhoneNumber, Email, Password, RoleName, IsActive, EmailConfirmed, RoleId, CountryID } = JSON.parse(
          JSON.stringify(this.data)
        );
        this.Id = Id;
        this.UserName = UserName;
        this.FullName = FullNameAr;
        if (this.isResetPassword)
          this.Password = "";
        else
          this.Password = Password;
        this.RoleName = RoleName;
        this.IsActive = IsActive;
        this.EmailConfirmed = EmailConfirmed;
        this.Email = Email;
        this.PhoneNumber = PhoneNumber;
        this.RoleId = RoleId;
        this.CountryId = CountryID;

        //this.checkPassword();

      }
    }
  },
  data() {
    return {
      passwordType: "password",
      contains_eight_characters: false,
      contains_number: false,
      contains_uppercase: false,
      contains_special_character: false,

      Id: null,
      UserName: null,
      FullName: null,
      Password: "",
      RoleName: null,
      RoleId:null,
      Email: null,
      IsActive: false,
      EmailConfirmed: false,
      PhoneNumber: null,
      CountryId: null,
      userInfo: {},
      settings: {

        maxScrollbarLength: 60,
        wheelSpeed: 0.6
      }
    };
  },

  created(){
    this.userInfo = JSON.parse(localStorage.getItem("userInfo"));


      if (!moduleCountries.isRegistered) {
        this.$store.registerModule("CountriesList", moduleCountries);
        moduleCountries.isRegistered = true;
       }

      if (!moduleUser.isRegistered) {
            this.$store.registerModule("UserList", moduleUser);
            moduleUser.isRegistered = true;
          }

       this.$store.dispatch("UserList/GetAllRoles");
       this.$store.dispatch("CountriesList/fetchDataListItems"); 

    }
 

  ,computed: {

    roles() {return this.$store.state.UserList.roles;},
    Countries() { return this.$store.state.CountriesList.countries; },
    isSidebarActiveLocal: {

      get() {
        this.$validator.reset();
        if(this.Id === undefined || this.Id == null){
          this.initValues();
        }
        return this.isSidebarActive;
      },
      set(val) {
        
        if (!val) {
          this.$validator.reset();
          this.initValues();
          this.$emit("closeSidebar");
        }
      }
    },
  isFormValid() {

    if (this.isResetPassword) {
        return this.Password && 
               this.contains_eight_characters && 
               this.contains_number && 
               this.contains_uppercase && 
               this.contains_special_character;
    }


  
    if (this.isNewUser) {
        return !this.errors.any() &&
               this.FullName &&
               this.RoleName &&
               this.Email &&
               this.PhoneNumber &&
               (this.RoleName !== 'SuperAdmin' ? this.CountryId !== null : true) &&
               this.Password &&
               this.contains_eight_characters &&
               this.contains_number &&
               this.contains_uppercase &&
               this.contains_special_character;
    }


    return !this.errors.any() &&
           this.FullName &&
           this.RoleName &&
           this.Email &&
           this.PhoneNumber &&
           (this.RoleName !== 'SuperAdmin' ? this.CountryId !== null : true);
}
  },
  methods: {

   
    showPassword() {
      if (this.passwordType == 'text')
        this.passwordType = 'password'
      else
        this.passwordType = 'text'
    },
    checkPassword() {
      
      this.password_length = this.Password.length;
      const format = /[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/;

      if (this.password_length > 8) {
        this.contains_eight_characters = true;
      } else {
        this.contains_eight_characters = false;
      }

      this.contains_number = /\d/.test(this.Password);
      this.contains_uppercase = /[A-Z]/.test(this.Password);
      this.contains_special_character = format.test(this.Password);

      if (this.contains_eight_characters === true &&
        this.contains_special_character === true &&
        this.contains_uppercase === true &&
        this.contains_number === true) {
        this.valid_password = true;
      } else {
        this.valid_password = false;
      }

    },

    initValues() {
      if (this.data.id) return;
      this.Id = null;
      this.UserName = null;
      this.FullName = null;
      this.Password = "";
      this.RoleName = null;
      this.RoleId = null;
      this.Email = null;
      this.PhoneNumber = null;
      this.IsActive = false;
      this.EmailConfirmed = false
      this.CountryId = this.userInfo.CountryId === null || this.userInfo.CountryId === undefined? null : this.userInfo.CountryId,
      this.contains_eight_characters= false,
      this.contains_number= false,
      this.contains_uppercase= false,
      this.contains_special_character= false

    },
    submitData() {
  
  this.$validator.validateAll().then(result => {
    if (result) {
      const obj = {
        Id: this.Id,
        UserName: this.Email,
        FullNameAr: this.FullName,
        FullNameEn: this.FullName,
        Password: this.Password,
        RoleName: this.RoleName,
        RoleId: this.RoleId,
        IsActive: this.IsActive,
        EmailConfirmed: this.EmailConfirmed,
        Email: this.Email,
        PhoneNumber: this.PhoneNumber,
        CountryId: this.CountryId,
      };

      // Close sidebar immediately
      this.$emit("closeSidebar");

      
      if (this.Id !== null && this.Id != '') {
        this.$store.dispatch("UserList/updateItem", obj).then(() => {
          this.$store.dispatch("UserList/fetchDataListItems");
          this.$vs.notify({
            time: 8000,
            color: "success",
            title: "Saved",
            text: "User Is Successfully Updated"
          });
          this.initValues();
        }).catch(err => {
          this.$vs.notify({
            time: 8000,
            color: "danger",
            title: "error",
            text: err.response.data.message
          });
          console.error(err);
        });
      } else {
        delete obj.Id;
        this.$store.dispatch("UserList/addItem", obj).then(() => {
          this.$store.dispatch("UserList/fetchDataListItems");
          this.$vs.notify({
            time: 8000,
            color: "success",
            title: "Saved",
            text: "User Is Successfully Created"
          });
          this.initValues();
        }).catch(err => {
          
          this.$vs.notify({
            time: 8000,
            color: "danger",
            title: "error",
            text: err.response.data.message
          });
          console.error(err);
        });
      }
    }
  });
},

    ResetPassword() {
  const obj = {
    Id: this.Id,
    Password: this.Password
  };

  this.$store.dispatch("UserList/UpdatePassword", obj).then(() => {
    this.$vs.notify({
      color: "success",
      time: 8000,
      title: this.$t("Success"),
      text: this.$t("Passwordchangedsuccessfully")
    });

    this.$emit("closeSidebar");
    this.initValues();

  }).catch(err => {
    const errorMessage = (err.response && err.response.data && err.response.data.message) 
                         ? err.response.data.message 
                         : "Error occurred";
    
    this.$vs.notify({
      time: 8000,
      color: "danger",
      title: "Error",
      text: errorMessage
    });
  });
}
  },
  components: {
    VuePerfectScrollbar,
    vSelect,
  }
};
</script>


<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  height: calc(100% - 4.3rem);
}
</style>
